import { PageHeaderTile, PageTileField, Flex, PrimaryButton } from 'lqx-react';
import * as React from 'react';
import SaveIcon from '@material-ui/icons/Save';
import { globalStore, RelationshipModel } from 'api';
import { Toolbar } from 'lqx-react/src';
import { Events } from '@type-r/models';

export const RelationshiptHeader = ({ relationship }: {
    relationship: RelationshipModel
}) => {
    return (
        <PageHeaderTile
            title= {relationship.id ? relationship.title : 'New relationship' }
            right={<PageTileField label="Conversation Ids count">{relationship.conversationIdList && relationship.conversationIdList.length}</PageTileField>}
            returnLink='/relationships'
            toolbar={
                <Toolbar>
                    <Flex grow />
                    <PrimaryButton
                        startIcon={<SaveIcon />}
                        disabled={!relationship.isValid()}
                        onClick={() => {
                            // $errorMessage.set(null);
                            if (relationship.isValid()) {
                                relationship
                                    .save().then(x => {
                                        globalStore.refreshRelationships();
                                        Events.trigger( 'navigate', `/relationships/all`);
                                    });
                               //     .catch((err) => $errorMessage.set(err));
                            } else {
                                // $errorMessage.set({ message: 'All fields must be properly filled' });
                            }
                        }}
                    >
                        Save
                </PrimaryButton>
                </Toolbar>}
        >
            <PageTileField label="Customer ref number">
                {relationship.Customer && relationship.Customer.externalRelationshipId}
            </PageTileField>
            <PageTileField label="Default Workflow Id">
                {relationship.defaultWorkflowMap && relationship.defaultWorkflowMap.id}
            </PageTileField>
            <PageTileField label="LQX Entitlement Id">
                {relationship.lqxId}
            </PageTileField>
            <PageTileField label="Updated on date">
            </PageTileField>
        </PageHeaderTile>
    );
};

